import styled from '@emotion/styled';

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
`;

const Inner = styled.div`
	max-width: 60rem;
	margin: 0 auto;
`;

const Body = styled.div`
	font-size: 2rem;
	line-height: 2.6rem;
`;

export default function WysiwygBlockDelta({ description }: { description: string }) {
	return (
		<Section id="description">
			<Inner>
				<Body>{description}</Body>
			</Inner>
		</Section>
	);
}
